module.exports = __webpack_public_path__ + "img/project1_8.png.6dad40ff.webp";